document.addEventListener('DOMContentLoaded', function() {

    // Search button
    const searchButton = document.querySelector('.search-form__submit-button');
    const searchInput = document.querySelector('.search-form__input');
        
    if (searchButton && searchInput) {
        searchButton.addEventListener('click', function() {
            
            if (searchInput.style.display === 'none' || searchInput.style.display === '') {
                searchInput.style.display = 'block'; 
            } else {
                searchInput.style.display = 'none';  
            }
        });
    }


    // 
    const scrollButton = document.querySelector('.scroll-down-button');

    // Check if the scroll button exists before adding the event listener
    if (scrollButton) {
        scrollButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent the default link behavior
            
            // Select the target section
            const targetSection = document.querySelector('.next-section');
            
            // Check if the target section exists before scrolling
            if (targetSection) {
                targetSection.scrollIntoView({ behavior: 'smooth' });
            }
        });
    }
    
});